import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import styled from 'styled-components';

import { CurrentUser } from 'entities/user/ui/CurrentUser/CurrentUser';
import { CurrentUserM } from 'entities/user/ui/CurrentUserM/CurrentUserM';
import { ApplicationTabs } from 'features/navigation/ui/ApplicationTabs/ApplicationTabs';
import { DodoIsLogo } from '../DodoIsLogo';

const HeaderStyled = styled(Layout.Header)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 auto;
	padding: 24px 0;
	height: 52px;
	background-color: #fff;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
		margin: 0 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		margin: 0 auto;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		width: 1200px;
	}
`;

const HeaderLinkStyled = styled(Link)`
	display: flex;
	align-items: center;
	height: 32px;
`;

const LogoContainerStyledStyled = styled.div`
	gap: 75px;
	display: flex;
	align-items: center;
`;

export const HeaderWrapperStyled = styled.div`
	width: 100%;
	border-bottom: 1px solid #f0f0f0;
`;

export const UserContainerStyled = styled.div`
	gap: 24px;
	display: flex;
	align-items: center;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		gap: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		gap: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		gap: 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		gap: 24px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		gap: 24px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		gap: 24px;
	}
`;

export const Header: React.FC = () => (
	<HeaderWrapperStyled>
		<HeaderStyled>
			<LogoContainerStyledStyled>
				<HeaderLinkStyled to='/'>
					<DodoIsLogo />
				</HeaderLinkStyled>
				<ApplicationTabs />
			</LogoContainerStyledStyled>
			<CurrentUser />
			<CurrentUserM />
		</HeaderStyled>
	</HeaderWrapperStyled>
);
